export enum ECommunityRoutes {
  COMMUNITY_STATE = '/community/:state'
}
